import { Box, Typography, useTheme } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

import { ButtonV1, TooltipLabel } from "components";
import HoverBlock from "./HoverBlock";

import { pascalCase, validateNull } from "utils";
import { SHIPMENT_STATUS } from "../../constant";

const ButtonView = ({
  row,
  errors,
  handleRefresh,
  shipmentApproval,
  handleResync,
}) => {
  const theme = useTheme();

  const getStatusColor = (status) => {
    switch (status) {
      case SHIPMENT_STATUS?.approved:
      case SHIPMENT_STATUS?.created:
        return theme.palette.success.dark;
      case SHIPMENT_STATUS?.rejected:
      case SHIPMENT_STATUS?.failed:
        return theme.palette.error.errorTextColor;
      default:
        return theme.palette.text.primary;
    }
  };

  const getLastActionDetails = (item) => ({
    [item?.status === SHIPMENT_STATUS?.rejected
      ? "Rejected by"
      : "Approved by"]: validateNull(item?.checker),
    "Modified at": item?.lastModifiedDate,
    "Created at": item?.createdDate,
  });

  const renderStatusInfo = () => (
    <Box display="flex" alignItems="center">
      <Typography
        fontSize={14}
        fontWeight="600"
        color={getStatusColor(row?.status)}
      >
        {pascalCase(row?.status)}
      </Typography>

      <TooltipLabel
        placement="right"
        title={
          <HoverBlock data={getLastActionDetails(row)} title="Action details" />
        }
        labelChildren={
          <InfoOutlined
            style={{ width: 16, marginLeft: 6, marginTop: 4 }}
            color="primary"
          />
        }
      />
    </Box>
  );

  const renderActionButtons = () => {
    if (errors?.length) {
      return (
        <ButtonV1
          variant="contained"
          title="Refresh"
          size="small"
          onClick={() => handleRefresh([row.id])}
        />
      );
    }

    if (row?.status === SHIPMENT_STATUS?.pending) {
      return (
        <>
          <ButtonV1
            variant="outlined"
            title="Reject"
            color="buttonError"
            size="small"
            onClick={() => shipmentApproval(row, "REJECT")}
          />
          <ButtonV1
            title="Create"
            size="small"
            onClick={() => shipmentApproval(row, "CREATE")}
          />
        </>
      );
    }

    return (
      <>
        {renderStatusInfo()}
        {row?.status === SHIPMENT_STATUS?.rejected && (
          <ButtonV1
            variant="outlined"
            title="Resync"
            size="small"
            onClick={() => handleResync(row)}
          />
        )}
      </>
    );
  };

  return (
    <Box display="flex" flexDirection="row" gap={2}>
      {renderActionButtons()}
    </Box>
  );
};

export default ButtonView;
